import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { Api } from '../enum/Api';
@Injectable()
export class packageSuggestionModalDisplayLogService {
  constructor(private httpService: HttpService) { }

  public registerPackageSuggestion(userId: string, businessId: string, suggestedPackage: string, acceptedSuggestion: boolean, discountIdentifier: string) : Observable<any>{
    return this.httpService.post('com.serasa.customer/packageSugestionModalDisplayLog/registerPackageSugestion', Api.One_Portal, {
      userId: userId,
      businessId: businessId,
      modalDisplayInfo: {
        suggestedPackage: suggestedPackage,
        acceptedSuggestion: acceptedSuggestion,
        discountIdentifier: discountIdentifier
      }

    });
  }

}
